<script setup lang="ts">
import { Quote } from 'lucide-vue-next';

const testimonials = [
    {
        quote: "Rewio a réduit notre temps de screening de 3 semaines à 4 jours. L'extraction IA est un game-changer pour nos méta-analyses.",
        name: 'Dr. Marie Laurent',
        role: 'Maître de conférences en épidémiologie',
        affiliation: 'Université de Bordeaux',
    },
    {
        quote: "Enfin un outil qui respecte la méthodologie PRISMA sans sacrifier la productivité. Mes doctorants l'adoptent systématiquement.",
        name: 'Pr. Thomas Mercier',
        role: 'Directeur de recherche',
        affiliation: 'INSERM',
    },
    {
        quote: 'Le matching PDF automatique nous a fait gagner des heures. Et le diagramme PRISMA se génère en un clic — impossible de revenir en arrière.',
        name: 'Sarah Chen, PhD',
        role: 'Post-doctorante en sciences de la santé',
        affiliation: 'Université de Montréal',
    },
];

const trustIndicators = [
    { value: '12+', label: 'Universités' },
    { value: '850+', label: 'Chercheurs actifs' },
    { value: '2 400+', label: 'Revues complétées' },
];
</script>

<template>
    <section class="border-t border-border/40 py-24">
        <div class="mx-auto max-w-5xl px-4">
            <div class="text-center">
                <span
                    class="mb-4 inline-block text-xs font-medium tracking-widest text-brand uppercase"
                >
                    Ils nous font confiance
                </span>
                <h2
                    class="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl"
                >
                    Adopté par des chercheurs exigeants
                </h2>
            </div>

            <!-- Trust indicators -->
            <div
                class="mt-12 flex flex-wrap items-center justify-center gap-10 border-y border-border/40 py-8"
            >
                <div
                    v-for="indicator in trustIndicators"
                    :key="indicator.label"
                    class="text-center"
                >
                    <p class="text-2xl font-semibold tracking-tight text-brand">
                        {{ indicator.value }}
                    </p>
                    <p class="mt-1 text-xs text-muted-foreground">
                        {{ indicator.label }}
                    </p>
                </div>
            </div>

            <!-- Testimonials -->
            <div class="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
                <div
                    v-for="testimonial in testimonials"
                    :key="testimonial.name"
                    class="group flex flex-col rounded-2xl border border-border/40 p-7 transition-colors hover:border-border"
                >
                    <Quote class="mb-4 h-5 w-5 text-brand/40" />
                    <blockquote
                        class="flex-1 text-sm leading-relaxed text-muted-foreground"
                    >
                        "{{ testimonial.quote }}"
                    </blockquote>
                    <div class="mt-6 border-t border-border/40 pt-5">
                        <p class="text-sm font-semibold text-foreground">
                            {{ testimonial.name }}
                        </p>
                        <p class="mt-0.5 text-xs text-muted-foreground">
                            {{ testimonial.role }}
                        </p>
                        <p class="text-xs text-brand">
                            {{ testimonial.affiliation }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
